import React, { useState } from 'react';
import { Heading, IconArrowHead } from '../../components';
import { richText } from '../../util/richText';
import { languagesHelper as language } from '../../util/languages';
import { useIntl } from '../../util/reactIntl';

import css from './ListingPage.module.css';

const MIN_LENGTH_FOR_LONG_WORDS = 20;

const SectionTextMaybe = props => {
  const { listing, text, heading, showAsIngress = false, name, publicData, locale, id, variantPrefix, listingTranslation } = props;
  const textClass = showAsIngress ? css.ingress : css.text;
  const content = richText(text, {
    linkify: true,
    longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS,
    longWordClass: css.longWord,
    breakChars: '/',
  });

  const intl = useIntl();
  const [showSection, setShowSection] = useState(true);

  return text ? (
    <section className={css.section}>
      {heading ? (
        <Heading as="h2" rootClassName={css.sectionTitle} onClick={() => setShowSection(!showSection)}>
          {language.labelsTranslator(id, intl)}
          <IconArrowHead direction={showSection ? "up" : "down"} />
        </Heading>
      ) : null}
      {showSection && (
        <p className={textClass}>{listingTranslation[`${name}_locale_${locale}`] || content}</p>
      )}
    </section>
  ) : null;
};

export default SectionTextMaybe;
